import useQuery from 'components/useQuery'
import { api } from 'api'
import { useEffect, useState } from 'react'
import { useToast } from '@chakra-ui/react'

export const useFetchFiles = (appId) => {
  const toast = useToast()
  const {
    isError,
    isLoading,
    response,
    request,
    error,
  } = useQuery((data) => api.admin.fetchFiles(data, appId))
  const [list, setList] = useState([])

  const clear = () => {
    setList([])
  }

  useEffect(() => {
    if (isError) {
      toast({
        title: 'Ошибка',
        description: error.response?.data?.errorText,
        status: 'error',
      })
    }
  }, [isError])

  useEffect(() => {
    if (response?.list) {
      setList(response?.list)
    }
  }, [response])

  return {
    fetchFiles: request,
    clearFiles: clear,
    isLoadingFetchFiles: isLoading,
    dataFiles: list,
  }
}
